// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"0fb5ecf3","423":"ba4f375e"}[chunkId] + ".chunk.js";
};